import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import useViewsSelector from "views/stores/useViewsSelector";
import SearchExplainContext from "views/components/contexts/SearchExplainContext";
import { buildSearchExecutionState } from "views/logic/slices/executeJobResult";
import { selectSearchTypesToSearch, selectSearchExecutionState } from "views/logic/slices/searchExecutionSelectors";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import useViewType from "views/hooks/useViewType";
import View from "views/logic/views/View";
import useView from "views/hooks/useView";
const SearchExplainContextProvider = ({ children }) => {
  const view = useView();
  const executionState = useViewsSelector(selectSearchExecutionState);
  const searchTypesToSearch = useViewsSelector(selectSearchTypesToSearch);
  const [searchExplain, setSearchExplain] = useState(
    void 0
  );
  const { mutateAsync: onSearchExplain } = useMutation({
    mutationFn: () => fetch(
      "POST",
      qualifyUrl(`views/search/${view.search.id}/explain`),
      buildSearchExecutionState(searchTypesToSearch, executionState)
    ),
    onSuccess: (result) => {
      setSearchExplain(result);
    }
  });
  const searchExplainContextValue = useMemo(() => {
    const getExplainForWidget = (queryId, widgetId, widgetMapping) => {
      var _a, _b, _c, _d, _e;
      const searchTypeId = (_a = widgetMapping == null ? void 0 : widgetMapping.get(widgetId)) == null ? void 0 : _a.first();
      return (_e = (_d = (_c = (_b = searchExplain == null ? void 0 : searchExplain.search) == null ? void 0 : _b.queries) == null ? void 0 : _c[queryId]) == null ? void 0 : _d.search_types) == null ? void 0 : _e[searchTypeId];
    };
    return { getExplainForWidget, explainedSearch: searchExplain };
  }, [searchExplain]);
  const viewType = useViewType();
  useEffect(() => {
    if (view.search.id && viewType === View.Type.Dashboard && view._value.title) {
      onSearchExplain();
    }
  }, [onSearchExplain, view.search.id, executionState, searchTypesToSearch, viewType, view._value.title]);
  return /* @__PURE__ */ React.createElement(SearchExplainContext.Provider, { value: searchExplainContextValue }, children);
};
export default SearchExplainContextProvider;
